import { memo } from "react";
import mobile_2 from "../../Assets/Images/Mobile-2.webp";

interface LearnerFeature {
  title: string;
  description: string;
}

const LEARNER_FEATURES: LearnerFeature[] = [
  {
    title: "Complete Course for Students",
    description:
      "Through video lectures, quizzes, and text books, this app assists you in your exam preparation.",
  },
  {
    title: "Vocational & Executive Trainings",
    description:
      "These trainings will assist you real-time skill sets in order to earn in a competitive environment.",
  },
  {
    title: "Language Learning",
    description:
      "App covers a vast set of languages so everyone could learn them in a cost effective range.",
  },
];

const EducationalFeatures = () => (
  <div className="w-100 my-5 pt-5">
    <div className="divider_bg py-2" />
    <div className="container-xxl px-3 bg-white p-0">
      <div className="row bg-white my-5 mx-0">
        <div className="col-12 col-lg-6">
          <div className="w-100 d-block overflow-hidden minh-500px text-sm-center text-start ms-0 mt-5 pt-4">
            <img
              src={mobile_2}
              alt="Mobile"
              className="mh-500px me-lg-0 w-100 me-0 pe-0 pe-lg-0 mw-440"
            />
          </div>
        </div>
        <div className="col-12 col-lg-6">
          <div className="w-100 mt-5 position-relative">
            <div className="d-flex align-items-center">
              <div>
                <div className="edu" />
              </div>
              <h5 className="text-muted ms-2 m-0">EDUCATIONAL</h5>
            </div>
            <div className="w-100">
              <h4 className="fw-bolder my-3 text-uppercase">
                Best Features For
                <br />
                Learners
              </h4>
              <ul className="px-0 ps-4 edu_list">
                {LEARNER_FEATURES.map((feature) => (
                  <li key={feature.title}>
                    <h5 className="fw-bolder">{feature.title}</h5>
                    <p className="text-break">{feature.description}</p>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="divider_bg py-2 mt-5" />
  </div>
);

export default memo(EducationalFeatures);
